import React, { useEffect, FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import {
  selectorCurrentDealItem,
  selectorCurrentDealIsLoading,
} from "src/redux/currentDeal/selector";
import { getCurrentDealAsync } from "src/redux/currentDeal/actions";
import { history } from "src/services/history";
import { DefaultDealRequest } from "src/page-components/cabinet/deals/[deal]/DefaultDealRequest";
import { ApprovedDealRequest } from "src/page-components/cabinet/deals/[deal]/ApprovedDealRequest";
import { getDealInitiator } from "src/page-components/cabinet/deals/constants";
import { Loader } from "src/components/Loader";
import { PATHNAMES } from "src/constants/routes";
import { Statuses } from "src/@types/deals";
import { Sizes } from "src/@types/sizes";
import { metaTrns } from "src/page-components/cabinet/deals/[deal]/trns";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const DealItem: FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const currentDeal = useAppSelector(selectorCurrentDealItem);
  const isLoading = useAppSelector(selectorCurrentDealIsLoading);

  const { deal } = useParams();

  if (
    currentDeal?.status === Statuses.DONE ||
    currentDeal?.status === Statuses.CANCELED
  ) {
    history.push(PATHNAMES.DEALS, { replace: true });
  }

  // CHANGE
  const isApproved = Statuses.IN_PROGRESS === currentDeal?.status;

  useEffect(() => {
    dispatch(getCurrentDealAsync(deal));
  }, [dispatch, deal]);

  // CHANGE
  if (!currentDeal && !isLoading) {
    return null;
  }

  const visibleUserInfo = currentDeal?.is_host
    ? currentDeal?.seller
    : currentDeal?.buyer;

  const metaName =
    currentDeal?.inquiry?.title || currentDeal?.clone?.company_name;

  return (
    <MetadataWrapper
      title={t(metaTrns.title, {
        name: metaName,
      })}
      description={t(metaTrns.description, {
        name: metaName,
      })}
    >
      {isLoading ? (
        <div className="flex justify-center items-center min-h-72">
          <Loader size={Sizes.XXL} />
        </div>
      ) : (
        <>
          {isApproved ? (
            <ApprovedDealRequest {...currentDeal} />
          ) : (
            <DefaultDealRequest
              is_host={currentDeal.is_host}
              dealId={currentDeal.id}
              chat={currentDeal.chat}
              userInfo={visibleUserInfo}
              {...getDealInitiator(currentDeal.inquiry, currentDeal.clone)}
            />
          )}
        </>
      )}
    </MetadataWrapper>
  );
};

export default DealItem;
